import React, { useCallback, useContext } from 'react';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles';

import { EadNode } from 'types';
import { GridActionButtonComponent } from 'components/grid/grid-types';
import {
  addEadToFavourites,
  removeEadFromFavourites,
} from 'modules/portfolio-favourite/favourite-api';
import { NotificationCtx } from 'components/notification/notification-hook';
import { NotificationVariant } from 'components/notification/notification-types';
import { AuthCtx } from 'components/auth/auth-ctx';
import { CircularProgress } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    navigationButton: {
      marginTop: theme.spacing(),
      alignSelf: 'baseline',
      width: '100%',
    },
  })
);

export const EadFavourite = ({
  item,
  refreshRootArchivalAid,
  refreshDetail,
}: GridActionButtonComponent) => {
  const classes = useStyles();
  const { userInfo } = useContext(AuthCtx);

  const { showNotification } = useContext(NotificationCtx);
  const [loading, setLoading] = React.useState(false);

  const eadNode = item as EadNode;
  const isFavourite = !!eadNode?.favourite;

  const handleAddToFavourites = useCallback(async () => {
    setLoading(true);
    //const response = await addEadToFavourites(getNodeId(eadNode)!);
    const response = await addEadToFavourites(eadNode.id);

    if (response.ok) {
      showNotification(
        'EAD uzel byl úspěšně přidán mezi oblíbené.',
        NotificationVariant.SUCCESS,
        5000
      );
      //refreshRootArchivalAid();
      refreshDetail();
    } else {
      showNotification(
        'Při přidávání EAD uzlu mezi oblíbené nastala chyba.',
        NotificationVariant.ERROR
      );
    }
    setLoading(false);
  }, [eadNode, showNotification, refreshDetail]);

  const handleRemoveFromFavourites = useCallback(async () => {
    setLoading(true);
    const response = await removeEadFromFavourites(eadNode.id);
    //const response = await removeEadFromFavourites(getNodeId(eadNode)!);

    if (response.ok) {
      showNotification(
        'EAD uzel byl úspěšně odebrán z oblíbených.',
        NotificationVariant.SUCCESS,
        5000
      );
      //refreshRootArchivalAid();
      refreshDetail();
    } else {
      showNotification(
        'Při odebíraní EAD uzlu z oblíbených nastala chyba.',
        NotificationVariant.ERROR
      );
    }
    setLoading(false);
  }, [eadNode, showNotification, refreshDetail]);

  if (!userInfo?.aisAuthenticated) {
    return <></>;
  }

  return (
    <Button
      disabled={loading}
      component="span"
      variant="outlined"
      color="primary"
      className={classes.navigationButton}
      onClick={isFavourite ? handleRemoveFromFavourites : handleAddToFavourites}
    >
      {loading ? (
        <span>
          Načítám... <CircularProgress size={12} />
        </span>
      ) : (
        <>{isFavourite ? 'Odstraň z oblíbených' : 'Přidej k oblíbeným'}</>
      )}
    </Button>
  );
};
